export const DATA_HOOKS = {
  root: 'create-group-root',
  groupsTypeDropdown: 'groups-type-dropdown',
  groupName: 'group-name',
  createButton: 'create-button',
  cancelButton: 'cancel-button',
};
